/* @flow */
import React from 'react';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import humanparser from 'humanparser';
import Input from 'components/Input.jsx';
import KeyConstants from 'constants/KeyConstants';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Link from 'components/Link.jsx';
import Menu from 'components/Menu.jsx';
import MenuItem from 'components/MenuItem.jsx';
import ProfilePicture from 'user/components/ProfilePicture.jsx';
import UserActions from 'user/UserActions';
import Text from 'components/Text.jsx';
import ToastActions from 'actions/ToastActions';
import SettingsStore from 'stores/SettingsStore';

import './styles/ProfileHeaderView.scss';

class ProfileHeaderView extends React.Component {
  state = {
    displayName: CurrentUser.getUser().getDisplayName(),
    gradeLevel: CurrentUser.getUser().getGradeLevel(),
  }

  static getStores() {
    return [CurrentUser];
  }

  static calculateState() {
    return {
      displayName: CurrentUser.getUser().getDisplayName(),
      gradeLevel: CurrentUser.getUser().getGradeLevel(),
    };
  }

  onChange = (event: any) => {
    this.setState({ displayName: event.target.value });
  }

  onError = (err: any) => {
    ToastActions.showAPIError(err);
    this.setState({
      displayName: CurrentUser.getUser().getDisplayName(),
      gradeLevel: CurrentUser.getUser().getGradeLevel(),
    });
  }

  saveSignature = () => {
    const { displayName } = this.state;
    if (displayName === CurrentUser.getUser().getDisplayName()) {
      return;
    }

    UserActions.update({ signature: displayName }).then(() => ToastActions.showSuccessToast('Signature saved'), this.onError);
  }

  saveName = () => {
    const { displayName } = this.state;
    if (displayName === CurrentUser.getUser().getDisplayName()) {
      return;
    }

    const human = humanparser.parseName(displayName);
    const data = {
      first_name: human.firstName,
      last_name: human.lastName || '',
    };
    UserActions.update(data).then(() => ToastActions.showSuccessToast('Name saved'), this.onError);
  }

  renderEditableDisplayName() {
    const onKeyDown = (event) => {
      if (event.keyCode === KeyConstants.ENTER) {
        this.refs.displayNameInput.getInputNode().blur();
      }
    };

    return (
      <div className="ProfileHeaderView-inputContainer">
        <Glyph name="pencil-stroke" color="eclipse" size="large" />
        <Input
          ref="displayNameInput"
          className="ProfileHeaderView-displayName"
          value={this.state.displayName}
          onBlur={CurrentUser.getUser().isTeacher() ? this.saveSignature : this.saveName}
          onKeyDown={onKeyDown}
          onChange={this.onChange}
        />
      </div>
    );
  }

  renderGradeByline() {
    const { gradeLevel } = this.state;
    const gradeText = gradeLevel ? gradeLevel.name : 'Set your grade level';
    const setGrade = (grade) => {
      const gradeObject = SettingsStore.getSetting('grades').find(g => g.code === grade);
      this.setState({ gradeLevel: gradeObject });
      UserActions.update({ grade_level: grade }).then(
        () => ToastActions.showSuccessToast('Grade level saved'),
        this.onError,
      );
    };

    const menu = (
      <Menu className="ProfileHeaderView-gradeMenu">
        {SettingsStore.getSetting('grades').map(grade => (
          <MenuItem key={grade.code} onSelect={setGrade}>
            {grade.name}
          </MenuItem>
        ))}
      </Menu>
    );

    return (
      <div className="ProfileHeaderView-byline">
        <LayerTrigger
          layer={menu}
          trigger="click"
          placement="bottom"
          alignment="middle">
          <Link href="#">
            <span className="ProfileHeaderView-gradeLabel">
              <Text color={gradeLevel ? 'thunder' : 'flame'} size="medium">{gradeText}</Text>
              <Glyph name="chevron-down" color="thunder" size="xsmall" />
            </span>
          </Link>
        </LayerTrigger>
      </div>
    );
  }

  renderSignatureByline() {
    return (
      <div className="ProfileHeaderView-byline">
        <Text italic color="thunder" size="xsmall">Your signature is what others will see when you send a message.</Text>
      </div>
    );
  }

  render() {
    const user = CurrentUser.getUser();
    return (
      <div className="ProfileHeaderView">
        <ProfilePicture user={user} />
        {this.renderEditableDisplayName()}
        {user.isStudent() && this.renderGradeByline()}
        {user.isTeacher() && this.renderSignatureByline()}
      </div>
    );
  }
}

export default Container.create(ProfileHeaderView);



// WEBPACK FOOTER //
// ./src/settings/components/ProfileHeaderView.jsx